import { Box, Stack, Typography } from '@mui/material'
import type { FC, PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'

import { COLORS } from '../../../../../../libs/ui/src/lib/constants'
import { unit } from '../../../../../../libs/ui/src/lib/utils'
import { SvgBuyNewAccommodation } from '../../../assets/images'

type ButtonBuyAccommodationWrapperProps = PropsWithChildren

export const ButtonBuyAccommodationWrapper: FC<ButtonBuyAccommodationWrapperProps> = ({ children }) => {
  const { t } = useTranslation()

  return (
    <Stack
      sx={{ paddingX: unit(8), paddingY: unit(9.5), position: 'relative', overflow: 'hidden' }}
      gap={unit(6)}
      flexDirection='column'
    >
      <SvgBuyNewAccommodation
        style={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
        }}
        preserveAspectRatio='xMidYMid slice'
      />
      <Box sx={{ position: 'absolute', inset: 0, backgroundColor: COLORS.red.dark, opacity: 0.9 }} />
      <Typography textAlign='center' variant='headlineL' color={COLORS.white} sx={{ position: 'relative' }}>
        {t('buttons.buy-accommodation')}
      </Typography>
      <Box sx={{ position: 'relative' }}>{children}</Box>
    </Stack>
  )
}
